module.exports = __webpack_public_path__ + "media/images/tour/m/zh-hans-a7846db84fb79177ad89cea12e769857.png";